/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { confirmEmailVerification } from '../fn/email-verification/confirm-email-verification';
import { ConfirmEmailVerification$Params } from '../fn/email-verification/confirm-email-verification';
import { EmailVerificationResponse } from '../models/email-verification-response';
import { sendEmailVerification } from '../fn/email-verification/send-email-verification';
import { SendEmailVerification$Params } from '../fn/email-verification/send-email-verification';

@Injectable({ providedIn: 'root' })
export class EmailVerificationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `sendEmailVerification()` */
  static readonly SendEmailVerificationPath = '/rest/email-verification';

  /**
   * Send email with link to confirm email of logged Auth0 account. Used when services return 403 with code EMAIL_NOT_VERIFIED - account has not verified email and user with this email already exists (e.g. user who logs in with Google signed up also with password, invited user signed up without link from invitation email). Required is only token of Auth0 account, no request body.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendEmailVerification()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendEmailVerification$Response(params?: SendEmailVerification$Params, context?: HttpContext): Observable<StrictHttpResponse<EmailVerificationResponse>> {
    return sendEmailVerification(this.http, this.rootUrl, params, context);
  }

  /**
   * Send email with link to confirm email of logged Auth0 account. Used when services return 403 with code EMAIL_NOT_VERIFIED - account has not verified email and user with this email already exists (e.g. user who logs in with Google signed up also with password, invited user signed up without link from invitation email). Required is only token of Auth0 account, no request body.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendEmailVerification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendEmailVerification(params?: SendEmailVerification$Params, context?: HttpContext): Observable<EmailVerificationResponse> {
    return this.sendEmailVerification$Response(params, context).pipe(
      map((r: StrictHttpResponse<EmailVerificationResponse>): EmailVerificationResponse => r.body)
    );
  }

  /** Path part for operation `confirmEmailVerification()` */
  static readonly ConfirmEmailVerificationPath = '/rest/email-verification/{hash}/confirm';

  /**
   * Confirm email by hash from email sent by /rest/email-verification. Service is public (link can be opened in any browser), no request body. Email of Auth0 account which requested confirmation is marked as verified, so account is used for user with this email. Token issued before confirmation still has not verified email - frontend has to get new token (silent refresh without cache or new login) before it calls other services. Can be called repeatedly.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `confirmEmailVerification()` instead.
   *
   * This method doesn't expect any request body.
   */
  confirmEmailVerification$Response(params: ConfirmEmailVerification$Params, context?: HttpContext): Observable<StrictHttpResponse<EmailVerificationResponse>> {
    return confirmEmailVerification(this.http, this.rootUrl, params, context);
  }

  /**
   * Confirm email by hash from email sent by /rest/email-verification. Service is public (link can be opened in any browser), no request body. Email of Auth0 account which requested confirmation is marked as verified, so account is used for user with this email. Token issued before confirmation still has not verified email - frontend has to get new token (silent refresh without cache or new login) before it calls other services. Can be called repeatedly.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `confirmEmailVerification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  confirmEmailVerification(params: ConfirmEmailVerification$Params, context?: HttpContext): Observable<EmailVerificationResponse> {
    return this.confirmEmailVerification$Response(params, context).pipe(
      map((r: StrictHttpResponse<EmailVerificationResponse>): EmailVerificationResponse => r.body)
    );
  }

}
